import { Info } from 'lucide-react';
import { EmailOtpRow } from './EmailOtpRow';
import { SecurityCard } from './SecurityCard';
import { TotpRow } from './TotpRow';

interface TwoFactorCardProps {
  email: string;
  hasPassword: boolean;
  totpEnabled: boolean;
  emailOtpEnabled: boolean;
}

/** Two-factor guards password sign-in only: a code sent to your email or phone is already a check of its own. */
export function TwoFactorCard({ email, hasPassword, totpEnabled, emailOtpEnabled }: TwoFactorCardProps) {
  return (
    <SecurityCard
      title="Two-factor for password sign-in"
      description="Asked after your password. Codes sent to your email or phone are already a check of their own, so they skip it."
      isDimmed={!hasPassword}
    >
      {!hasPassword && (
        <p className="mt-3 flex items-start gap-2 rounded-md bg-page px-3 py-2 text-sm text-fg">
          <Info className="mt-0.5 size-4 shrink-0 text-muted" />
          Only for signing in with a password. You have no password, so there is nothing to guard.
        </p>
      )}
      <ul className="mt-2 divide-y divide-line">
        <TotpRow isOn={totpEnabled} canTurnOn={hasPassword} />
        <EmailOtpRow email={email} isOn={emailOtpEnabled} canTurnOn={hasPassword} />
      </ul>
    </SecurityCard>
  );
}
